import { useEffect, useRef } from "react";

export default function ContactHero() {
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const timer = setTimeout(() => {
      el.classList.add("opacity-100", "translate-y-0");
      el.classList.remove("opacity-0", "translate-y-6");
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative h-[420px] md:h-[520px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20premium%20residential%20real%20estate%20office%20building%20Bengaluru%20India%20with%20lush%20green%20landscaping%20elegant%20architecture%20glass%20facade%20warm%20golden%20hour%20lighting%20professional%20corporate%20setting%20clean%20minimalist%20design%20upscale%20property%20development%20company%20headquarters%20with%20manicured%20gardens%20and%20palm%20trees&width=1440&height=520&seq=contact-hero-001&orientation=landscape"
          alt="Urban Infra Contact"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A]/80 via-[#1B2A4A]/60 to-[#1B2A4A]/30"></div>
      </div>

      <div ref={heroRef} className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 opacity-0 translate-y-6 transition-all duration-700">
        <div className="flex items-center gap-2 text-white/70 text-sm mb-5">
          <a href="/" className="hover:text-white transition-colors cursor-pointer">Home</a>
          <i className="ri-arrow-right-s-line text-[#7FBF3F]"></i>
          <span className="text-white font-medium">Contact</span>
        </div>

        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/80 text-xs font-medium px-4 py-1.5 rounded-full mb-5">
            <i className="ri-map-pin-line text-[#7FBF3F]"></i>Bengaluru, Karnataka
          </div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
            Contact Us
          </h1>
          <p className="text-white/85 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
            Get in touch with Urban Infra for project details, site visits, and expert property guidance on Sarjapur Road, Bengaluru.
          </p>
          <div className="flex flex-wrap gap-3">
            <a href="tel:+919945124133" className="inline-flex items-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-semibold text-sm px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line"></i>Call Now
            </a>
            <a href="https://wa.me/919945124133" target="_blank" rel="nofollow noreferrer" className="inline-flex items-center gap-2 border-2 border-white/50 text-white hover:bg-white/10 font-semibold text-sm px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-whatsapp-line"></i>WhatsApp Us
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}
